import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager  } from 'ng-jhipster';

import { Feed } from './feed.model';
import { FeedService } from './feed.service';

@Component({
    selector: 'dcs-feed-detail',
    templateUrl: './feed-detail.component.html'
})
export class FeedDetailComponent implements OnInit, OnDestroy {

    feed: Feed;
    private subscription: Subscription;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private feedService: FeedService,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInFeeds();
    }

    load(id) {
        this.feedService.find(id).subscribe((feed) => {
            this.feed = feed;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInFeeds() {
        this.eventSubscriber = this.eventManager.subscribe(
            'feedListModification',
            (response) => this.load(this.feed.id)
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed-detail.component.ts